export default "//0f174046-a3c4-46d7-88af-9cfef9e6bcb2.selcdn.net/webpack/production/ddb20849cf36202e3ad0a778216d5a17.svg";